import React, { Component } from 'react';
import { Row, Col, Nav, Button } from 'react-bootstrap';
import { ReactComponent as PythonLogo } from '../assets/python-logo.svg';
import { ReactComponent as RubyLogo } from '../assets/ruby-logo.svg';
import { ReactComponent as MysqlLogo } from '../assets/mysql-logo.svg';
import { ReactComponent as ReactLogo } from '../assets/react-logo.svg';

export default class Header extends Component {
  render() {
    return (
      <header className="header">
        <Row className="header__base">
          <Col xs="6" className="header__left">
            <ul className="header__skills">
              <li>
                <PythonLogo className="python-logo" />
              </li>
              <li>
                <RubyLogo className="ruby-logo" />
              </li>
              <li>
                <MysqlLogo className="mysql-logo" />
              </li>
              <li>
                <ReactLogo className="react-logo" />
              </li>
            </ul>
          </Col>
          <Col xs="6" className="header__right">
            <Nav className="justify-content-end header__navbar" activeKey="/about-me">
              <Nav.Item>
                <Nav.Link href="#about-me">About me</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#skills">Skills</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#experience">Experience</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#education">Education</Nav.Link>
              </Nav.Item>
            </Nav>

            <div className="header__main">
              <h3 className="header__main__subheading">VLADIMIR ALFEROV</h3>
              <h1 className="header__main__heading">BACKEND DEVELOPER</h1>
              <a
                className="link"
                target="blank"
                href="https://www.linkedin.com/in/vladimir-alferov-01991516b/"
              >
                <Button size="lg" className="button">
                  Hire me!
                </Button>
              </a>
            </div>
          </Col>
        </Row>
        <Row className="header__print">
          <div className="header__main">
            <h3 className="header__main__heading">VLADIMIR ALFEROV</h3>
            <h5 className="header__main__subheading">BACKEND DEVELOPER</h5>
            <div>
              <a className="footer-href" href="tel:+79634694656">
                {' '}
                tel number: +7 (963) 469-46-56{' '}
              </a>
            </div>
            <div>
              <a className="footer-href" href="mailto:vladim.alferov@gmail.com">
                {' '}
                email: vladim.alferov@gmail.com
              </a>
            </div>
            <div>
              <a
                className="link"
                target="blank"
                href="https://www.linkedin.com/in/vladimir-alferov-01991516b/"
              ></a>
            </div>
          </div>
        </Row>
      </header>
    );
  }
}
